export default function isAndroid() {
  return /Android/i.test(window.navigator.userAgent);
}
